import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=349b40b2&scoped=true"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=349b40b2&prod&lang=scss&scoped=true"
import style1 from "./framework.vue?vue&type=style&index=1&id=349b40b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b40b2",
  null
  
)

export default component.exports